<template>
	<div
		class="g-block-file-header"
		:class="{
			'g-block-file-header--edit': editable,
			'is-active': editable && active,
			'g-block-file-header--h5': h5,
		}"
		@click="onWrapClick"
	>
		<HeaderFilesPreview :items="fileData.items" force-list-layout :editable="editable" />
	</div>
</template>

<script>
	import HeaderFilesPreview from '../../../components/HeaderFilesPreview.vue';
	import { normalizeFileHeaderData } from '../../../utils/fileHeader.js';

	export default {
		name: 'GBlockFileHeader',
		components: { HeaderFilesPreview },
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			fileData() {
				return normalizeFileHeaderData(this.data);
			},
		},
		methods: {
			onWrapClick() {
				if (this.editable) {
					this.$emit('select');
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-file-header {
		box-sizing: border-box;

		:deep(.g-header-files-preview__list) {
			margin: 0;
		}

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}
</style>
